module.exports = __webpack_public_path__ + "img/booth-table-6.95bc99c7.png";